var React = require('react');

function CloseIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.41502 8.00017 6.29178-6.29207c.3909-.39058.3909-1.024325 0-1.414911-.3909-.3909188-1.0239-.3909188-1.4148 0l-6.29183 6.292061-6.29214-6.292061c-.3909-.3909188-1.02395-.3909188-1.414853 0-.3909027.390586-.3909027 1.024331 0 1.414911l6.292133 6.29207-6.292133 6.29203c-.3909027.3906-.3909027 1.0244 0 1.4149.195452.1952.451606.2929.707423.2929.25583 0 .51198-.0977.70743-.2932l6.29214-6.29205 6.29183 6.29205c.1954.1955.4516.2932.7074.2932s.512-.0977.7074-.2932c.3909-.3906.3909-1.0243 0-1.4149z"}));
}

CloseIconInline.defaultProps = {"height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
